import React, {Component} from "react"
import {
	WindowScroller,
	AutoSizer,
	List,
	InfiniteLoader,
} from "react-virtualized"

export default class Scroller extends Component {
	render() {
		const {loadMoreRows, rowsLoaded} = this.props

		const rowCount = rowsLoaded + 2
		const rowHeight = 100
		const isRowLoaded = ({index}) => {
			return index < rowsLoaded
		}
		const rowRenderer = ({index, key, style}) => {
			return (
				<div key={key} style={style}>
					{index < rowsLoaded ? index : ""}
				</div>
			)
		}

		return (
			<InfiniteLoader
				isRowLoaded={isRowLoaded}
				loadMoreRows={loadMoreRows}
				rowCount={rowCount}
			>
				{({onRowsRendered, registerChild}) => (
					<WindowScroller>
						{({height, isScrolling, onChildScroll, scrollTop}) => (
							<AutoSizer disableHeight>
								{({width}) => (
									<List
										autoHeight
										height={height}
										isScrolling={isScrolling}
										onScroll={onChildScroll}
										scrollTop={scrollTop}
										width={width}
										onRowsRendered={onRowsRendered}
										ref={registerChild}
										rowCount={rowCount - 2}
										rowRenderer={rowRenderer}
										rowHeight={rowHeight}
									/>
								)}
							</AutoSizer>
						)}
					</WindowScroller>
				)}
			</InfiniteLoader>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Scroller.js